// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import award01Icon from "@/assets/icons/award-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Award01IconProps = Omit<IconProps, "name">;

export function Award01Icon(props: Award01IconProps): React.ReactNode {
  return <Icon name={award01Icon} {...props} />;
}
